function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "noun_FAQ_1272960",
  fillRule: "nonzero",
  fill: "#000000"
}, React.createElement("path", {
  fill: "currentColor",
  d: "M88,44 C88,68.3015667 68.3011413,88 44,88 C19.7004385,88 0,68.3007596 0,44 C0,19.6992405 19.7004385,0 44,0 C68.3011413,0 88,19.6984334 88,44 Z M84.2105272,44 C84.2105272,21.7913202 66.2082918,3.78947368 44,3.78947368 C21.7932545,3.78947368 3.78947276,21.7921606 3.78947276,44 C3.78947276,66.2078392 21.7932545,84.2105264 44,84.2105264 C66.2082918,84.2105264 84.2105272,66.2086798 84.2105272,44 Z M44.0581596,69.1428571 C41.7438225,69.1428571 39.8676834,67.2667168 39.8676834,64.952381 C39.8676834,62.6380451 41.7438225,60.7619048 44.0581596,60.7619048 C46.3724968,60.7619048 48.2486358,62.6380451 48.2486358,64.952381 C48.2486358,67.2667168 46.3724968,69.1428571 44.0581596,69.1428571 Z M56.6295882,31.4290994 C56.6295882,37.6582345 52.0990842,42.8292132 46.1533977,43.8267104 L46.1533977,54.3485067 L41.9629215,54.3485067 L41.9629215,39.8100518 L44.0581596,39.8100518 C48.6868297,39.8100518 52.439112,36.0577716 52.439112,31.4290994 C52.439112,26.8000383 48.6868507,23.047619 44.0581596,23.047619 C39.4294979,23.047619 35.6772072,26.8000056 35.6772072,31.4288354 L35.6772072,33.5240735 L31.486731,33.5240735 L31.486731,31.4288354 C31.486731,24.4856932 37.1151398,18.8571429 44.0581596,18.8571429 C51.0012297,18.8571429 56.6295882,24.4857422 56.6295882,31.4290994 Z",
  id: "Shape"
})));

var SvgUnsupported = function SvgUnsupported(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    fill: "currentColor",
    width: "88px",
    height: "88px",
    viewBox: "0 0 88 88",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgUnsupported, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/unsupported.ff54cd29.svg";
export { ForwardRef as ReactComponent };